module.exports = "/_next/static/images/74ec7657e37764e6fa49f5f1df909754-savings-md.jpg.webp";